import AitiCoreValidatorPostCodeFormatter from './postcode/formatter';

export default class AitiCoreValidatorPostCode {

    validate(postCode: string, country: string): boolean {
        return this._format(postCode, country) != null;
    }

    format(postCode: string, country: string): string {
        let format = this._format(postCode, country);
        return format ? format : postCode;
    }

    isCountrySupported(country: string): boolean {
        return AitiCoreValidatorPostCode._getFormatter(country) !== null;
    }

    private _format(postCode: string, country: string): string | null {
        return this.isCountrySupported(country) ? AitiCoreValidatorPostCode._getFormatter(country).call(this, AitiCoreValidatorPostCode._getCleanedPostCode(postCode)) : null;
    }

    private static _getFormatter(country: string): Function | null {
        country = country.toUpperCase();
        return typeof AitiCoreValidatorPostCodeFormatter[country] !== 'undefined' ? AitiCoreValidatorPostCodeFormatter[country] : null;
    }

    private static _getCleanedPostCode(postCode: string): string {
        return postCode.replace(/\s|-/g, '').toUpperCase();
    }
}
